module.exports = __webpack_public_path__ + "static/media/Hydraulics_Main_Image.eef991fc.png";